import { LotteryClass } from '../../interfaces/lottery-class';
import { Order } from '../../interfaces/order';
import { Share } from '../../interfaces/share';
import { ApiParameters } from './api-parameters';
import { ApiPostRequest } from './api-post-request';

export class ShareAddReservationRequest extends ApiPostRequest
{
    public constructor(order: Order | number, share: Share, lotteryClass: LotteryClass | number, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('orderid', typeof order === 'number' ? order : order.Id)
            .addQueryParameter('lotteryclassid', typeof lotteryClass === 'number' ? lotteryClass : lotteryClass.Id)
            .addQueryParameter('ticketnumber', share.Ticket.TicketNumber)
            .addQueryParameter('shareletter', share.Name);

        super('sharereservation', parameters, null, null, webapiBasepath);
    }
}

